import {headers} from '../common'

async function upload(file) {
  const data = new FormData();
  data.append("image", file);
  data.append("type", "avatar")
  return fetch('/api/upload', {
    method: 'POST',
    headers: {
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    },
    body: data,
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { upload }
